import axios from "axios";
import { HttpClient, RequestParams } from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";

import { ACCESS_TOKEN, LANGUAGE_CODE } from "../../utils/helpers/constants";

import {
  ICreateTag,
  IExportTagExcel,
  IUpdateTag,
} from "../../models/tag/request";
import { ITag, ITagDetails } from "../../models/tag/response";
import { ITagQuery } from "../../models/tag/query";

class TagService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getAllTags = (query: ITagQuery, params?: RequestParams) =>
    this.http.request<IBaseListingResponse<ITag>>({
      path: `/tags`,
      method: "GET",
      query,
      ...params,
    });

  getTag = (id: number, params?: RequestParams) =>
    this.http.request<ITagDetails>({
      path: `/tags/${id}`,
      method: "GET",
      ...params,
    });

  createTag = (data: ICreateTag, params?: RequestParams) =>
    this.http.request<ITag>({
      path: "/tags",
      method: "POST",
      body: data,
      ...params,
    });

  updateTag = (id: number, data: IUpdateTag, params?: RequestParams) =>
    this.http.request<ITag>({
      path: `/tags/${id}`,
      method: "PUT",
      body: data,
      ...params,
    });

  deleteTag = (id: number, params?: RequestParams) =>
    this.http.request<ITag>({
      path: `/tags/${id}`,
      method: "DELETE",
      ...params,
    });

  exportExcel = (data: IExportTagExcel, query: ITagQuery) =>
    axios.post(` ${process.env.REACT_APP_BASE_API_URL}/tags/export`, data, {
      headers: {
        authorization: `Bearer ${
          localStorage.getItem(ACCESS_TOKEN) ||
          sessionStorage.getItem(ACCESS_TOKEN)
        }`,
        "Content-Type": "application/json",
        "accept-language": `${
          localStorage.getItem(LANGUAGE_CODE) ??
          process.env.REACT_APP_DEFAULT_LANGUAGE
        }`,
      },
      params: query,
      responseType: "arraybuffer",
    });
}

export default TagService;
